var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wx-menu',{attrs:{"position":_vm.position}},[_c('wx-menu-item',{nativeOn:{"click":function($event){_vm.clearHistory(_vm.currentChatId)}}},[_vm._v("清屏")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b947118","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/ChatAreaMenu.vue
// module id = null
// module chunks = 